module.exports = __webpack_public_path__ + "180ea9dce4e8e0c1bad87a1e3ac818aa.png";